export const PLUGIN_ID = 'tree-menus'
